<template>
<div class="questionList btn-operate-list">
    <div class="out-box" v-for="(obj,index) in dataList" :key="index">
        <div class="left">
            <div class="subjectBox">
                <div class="subjectTitle">
                    <span>{{index + 1}}.</span>
                    <span>（{{obj.questiontype | typeName}}，分值{{obj.defaultscore}}）</span>
                </div>
                <div v-html="obj.subject"></div>
                <div class="subjectMain">
                    <span class="lable">答案：</span>
                    <div class="answerBox">
                        <!--选择题-->
                        <div v-if="['1','2','3'].indexOf(obj.questiontype) > -1">
                            <div v-for="(obj2,idx) in obj.optionslist" :key="idx">
                                <div class="selectSub">
                                    <span>{{letter[idx]}}、</span>
                                    <span v-html="obj2.optionsinfo"></span>
                                    <b v-show="obj2.isrightanswer=='1'">（正确答案）</b>
                                </div>
                            </div>
                        </div>
                        <!--判断题-->
                        <div class="selectSub" v-if="obj.questiontype=='4'">{{obj.finalanswer==='T'?'正确':'错误'}}</div>
                        <!--问答题-->
                        <div class="selectSub" v-if="obj.questiontype=='6'" v-html="obj.referenceanswer"></div>
                        <!--填空题-->
                        <div class="answerOtherBox" v-if="obj.questiontype=='5'">{{obj.finalanswerblank.answerblank.join(',')}}</div>
                    </div>
                </div>
            </div>
        </div>
        <div class="right">
             <span class="separator-btn">
                <el-button @click="handleEdit(index)" type="text" size="small">编辑</el-button>
             </span>
            <span class="separator-btn">
                <el-button @click="handleDel(index)" type="text" size="small">删除</el-button>
            </span>
        </div>
    </div>
</div>
</template>

<script>
import {_filter, question, letter} from 'api/enumCode'
export default {
    name: 'questionList',
    props: ['dataList'],
    data() {
        return {
            tablist: question.type,
            letter: letter
        }
    },
    mounted() {
    },
    methods: {
        handleEdit(index) {
            this.$emit('editQues', index)
        },
        handleDel(index) {
            this.$emit('delQues', index)
        }
    },
    filters: {
        typeName: function (value) {
            return _filter(value, question.type)
        }
    },
    watch: {},
    computed: {},
    components: {}
}
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
.questionList {
    line-height: 28px;
    .out-box {
        display: flex;
        justify-content: space-between;
        align-items: center;
        background: #F5F7FA;
        padding: 20px;
        width: 750px;
        box-sizing: border-box;
        .left{
            /*flex-grow: 1;*/
            width: 520px;
        }
        .right{
            flex-grow: 0 !important;
            flex-shrink: 0;
            margin-left: 15px;
        }
        .subjectBox{
            .subjectTitle{
            }
            .subjectMain{
                display: flex;
                margin-top: 30px;
                .lable{
                    width: 50px;
                    flex-grow: 0;
                    flex-shrink: 0;
                }
                .answerBox{
                    display: flex;
                    flex-direction: column;
                    .selectSub{
                        display: flex;
                        margin-bottom: 20px;
                        b{
                            color: #909399;
                        }
                    }
                    .selectSub:last-child{
                        margin-bottom: 0;
                    }
                    .otherSub{
                        display: flex;
                        flex-direction: row;
                    }
                }
                .answerOtherBox{
                    display: flex;
                    flex-direction: row;
                    .otherSub{
                        margin-right: 10px;
                    }
                }
            }
        }
    }
}
</style>
